import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "media-info"
}
const _hoisted_3 = { class: "language" }

import { Media } from '@/models/media.model';
import { computed, PropType } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MediaItem',
  props: {
  media: { type: Object as PropType<Media>, required: true },
  showOptions: { type: Array, default: () => ['use'] },
  showInfo: { type: Boolean, default: () => false },
  disabled: { type: Boolean, default: () => false },
},
  emits: ['use', 'edit', 'remove', 'view'],
  setup(__props, { emit: __emit }) {

const props = __props;

const src = computed<string>(() =>
  props.media.file ? `/file/${props.media.file.uuid}/small.webp` : '',
);

const emit = __emit;

const use = () => {
  emit('use', props.media);
};
const edit = () => {
  emit('edit', props.media);
};
const remove = () => {
  emit('remove', props.media);
};
const view = () => {
  emit('view', props.media);
};

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    elevation: "4",
    class: "mb-4 media-item"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass({ 'image-container': true, 'showing-info': !__props.showInfo })
          }, [
            _createElementVNode("img", {
              src: src.value,
              class: "image"
            }, null, 8, _hoisted_1),
            (__props.showInfo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("h4", null, _toDisplayString(__props.media.description), 1),
                  _createElementVNode("p", null, "Purpose: " + _toDisplayString(__props.media.purpose), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_v_tooltip, {
                text: `This file will be used for ${
              __props.media.file?.language
            } language${__props.media.file?.language === 'all' ? 's' : ''}`
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_chip, _mergeProps({
                    color: __props.media.file?.language === 'all' ? 'primary' : 'red',
                    variant: "flat"
                  }, props), {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.media.file?.language), 1)
                    ]),
                    _: 2
                  }, 1040, ["color"])
                ]),
                _: 1
              }, 8, ["text"])
            ])
          ], 2)
        ]),
        _: 1
      }),
      (__props.showOptions.length && !__props.disabled)
        ? (_openBlock(), _createBlock(_component_v_card_actions, { key: 0 }, {
            default: _withCtx(() => [
              (__props.showOptions.includes('use'))
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    density: "compact",
                    variant: "flat",
                    style: {"font-size":"11px"},
                    onClick: use,
                    color: "success"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('media.use')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (__props.showOptions.includes('edit'))
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 1,
                    density: "compact",
                    variant: "flat",
                    style: {"font-size":"11px"},
                    onClick: edit,
                    color: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('media.editShort')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_btn, {
                density: "compact",
                variant: "flat",
                style: {"font-size":"11px"},
                onClick: view
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('media.view')), 1)
                ]),
                _: 1
              }),
              (__props.showOptions.includes('remove'))
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 2,
                    density: "compact",
                    variant: "flat",
                    style: {"font-size":"11px"},
                    onClick: remove,
                    color: "warning"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('media.remove')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})